<template>
  <div>
    <div class="page-title">Edit Entry</div>
    <Form v-if="form" v-model="form" :submit="update" btnText="Update Entry" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.lists-entries.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ListEntry.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.ListEntry.update(this.form);
      this.$router.push("/widgets/lists");
    },
  },
};
</script>

<style></style>
